import http from "@/utils/request";
import axios from "axios";
//登录
export const userlogin = (data) => {
  return http.post("/Admin/Admin/adminLogin",data);
};
//获取用户列表
export const getUserList = (params) => {
  return http.get("/Home/Home/getUserList", {
    params: params,
  });
};
//获取用户列表
export const userListSave = (params) => {
  return http.get("/Home/Home/userListSave", {
    params: params,
  });
};

//获取用户列表
export const delUserList = (params) => {
  return http.get("/Home/Home/delUserList", {
    params: params,
  });
};

//获取儿童列表
export const getAdminData = (params) => {
  return http.get("/Home/Home/childrenList", {
    params: params,
  });
};

//编辑儿童
export const editAdminData = (data) => {
  return http.get("/Home/Home/childrenSave", {
    params: data,
  });
};

//删除儿童
export const deleteAdminData = (data) => {
  return http.get("/Home/Home/childrenDel", {
    params: data,
  });
};

//疫苗列表
export const getGoodsData = (params) => {
  return http.get("/Home/Home/vaccinesList", {
    params: params,
  });
};

//编辑疫苗
export const editGoodsData = (data) => {
  return http.get("/Home/Home/vaccinesSave", {
    params: data,
  });
};

//删除疫苗
export const deleteGoodsData = (data) => {
  return http.get("/Home/Home/vaccinesDel", {
    params: data,
  });
};

//预约列表
export const getClassList = (params) => {
  return http.get("/Home/Home/reservationList", {
    params: params,
  });
};
//预约审核
export const saveClass = (params) => {
  return http.get("/Home/Home/reservationSave", {
    params: params,
  });
};


//Medic列表
export const getMedicList = (data) => {
  return http.get("Home/Home/getFeedback", {
    params: data,
  });
};



// //删除商品分类
// export const delClass = (data) => {
//   return http.post("/Admin/Admin/delClass", data);
// };
// //编辑商品分类
// export const classAdd = (data) => {
//   return http.post("/Admin/Admin/classAdd", data);
// };



//修改Medic
export const saveMedic = (data) => {
  return http.post("/Admin/Admin/saveMedic", data);
};

//Medic列表
export const getCustomerList = (data) => {
  return http.post("/Admin/Admin/getCustomerList", data);
};
//修改Medic
export const saveCustomer = (data) => {
  return http.post("/Admin/Admin/saveCustomer", data);
};

